// extracted by mini-css-extract-plugin
export default {"mainHeadingWrapper":"PatientPortalHomePage_mainHeadingWrapper__bHhdw","borderBox":"PatientPortalHomePage_borderBox__o5HIU","dateWrapper":"PatientPortalHomePage_dateWrapper__ETHZl"};